module.exports = __webpack_public_path__ + "img/no_questions.cb6cc369.svg";